var _g, _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPayInvoices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 121,
    viewBox: "0 0 120 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_82)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 60.5C1 27.9152 27.4152 1.5 60 1.5V1.5C92.5848 1.5 119 27.9152 119 60.5V60.5C119 93.0848 92.5848 119.5 60 119.5V119.5C27.4152 119.5 1 93.0848 1 60.5V60.5Z",
    fill: "#F4F9FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.8196 46.1391C99.8196 46.1391 112.858 47.4828 113.753 36.0929C114.648 24.7031 101.708 18.2617 93.8985 21.1029C86.0892 23.944 95.4293 43.1354 79.9463 51.0343C79.9463 51.0343 69.1896 63.1519 60.9302 61.5256C52.6709 59.8993 57.1754 36.5601 46.7435 35.6528C36.3116 34.7456 32.763 36.4365 32.763 36.4365",
    stroke: "#CCD6DD",
    strokeWidth: 2.03,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3.05 10.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6633 40.6347L66.2124 39.3466L64.1954 82.0803L92.6464 83.3684L94.6633 40.6347Z",
    fill: "#C1C1C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.793 37.8906L66.3421 36.6025L64.3251 79.3362L92.7761 80.6243L94.793 37.8906Z",
    fill: "#E6EBEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5103 41.0025L68.3266 39.9076L66.8698 70.7735L91.0535 71.8684L92.5103 41.0025Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.9478 59.1002L73.2078 58.5234L72.9592 63.7902L85.6993 64.367L85.9478 59.1002Z",
    fill: "#00A0F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.2143 113.616L87.9882 92.8801L108.539 87.7865L115.774 109.796L91.2143 113.616Z",
    fill: "#70CAF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4695 82.909L88.77 89.3465L89.2707 92.5653L107.248 88.1068L104.947 79.4121C104.947 79.4121 105.544 68.534 101.686 62.1152C99.948 59.1319 98.8672 55.8141 98.5153 52.3815C98.1665 49.2232 93.5288 49.2092 93.1702 52.3712C93.0287 53.7225 93.1934 56.3556 93.6287 58.9819C93.8102 60.089 93.7464 61.2226 93.4419 62.3033C92.7142 64.9245 91.6011 70.0207 93.1378 72.5422L92.6243 83.3808L82.4695 82.909Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M79.2917 77.6252C80.4779 77.4407 81.2906 76.3342 81.107 75.1538C80.9234 73.9735 79.8129 73.1662 78.6267 73.3507C77.4406 73.5353 76.6278 74.6418 76.8115 75.8221C76.9951 77.0025 78.1055 77.8098 79.2917 77.6252Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M92.6403 83.3695L95.7101 90.9654L89.2707 92.5654L88.77 89.3465L82.4695 82.9091L92.6403 83.3695Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2955 97.7673L64.5764 92.9198C64.5764 92.9198 67.7853 90.6481 71.6073 88.2811C75.4292 85.9141 76.8994 82.8273 76.0191 80.7753C75.1388 78.7233 70.6943 76.7738 70.6943 76.7738C70.6943 76.7738 76.8643 64.1113 76.8199 61.7653C76.7755 59.4193 74.6453 58.8645 72.2907 60.8748C69.9362 62.885 65.7903 69.7247 65.7903 69.7247C65.7903 69.7247 56.4609 67.002 53.5678 70.3589C50.6746 73.7158 51.0109 83.0043 47.4825 91.6089L63.2955 97.7673Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0173 91.035L65.1852 96.0599L61.9826 118.78L36.5941 122.114L46.0173 91.035Z",
    fill: "#00A0F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1364 47.193L74.093 46.696L73.7395 54.8863L85.783 55.3834L86.1364 47.193Z",
    fill: "#335C75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8222 31.0517L17.4715 30.0816L30.3509 40.5958L33.8222 31.0517Z",
    fill: "#FFD200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8337 33.7711L33.8056 38.215L31.4388 37.5995L32.8337 33.7711Z",
    fill: "#FFD200"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M32.8337 33.7711L33.8056 38.215L31.4388 37.5995L32.8337 33.7711Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M17.4715 30.0816L32.8337 33.7711L31.6824 36.9324L17.4715 30.0816Z",
    fill: "black"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 118.5C27.9675 118.5 2 92.5325 2 60.5H0C0 93.6371 26.8629 120.5 60 120.5V118.5ZM118 60.5C118 92.5325 92.0325 118.5 60 118.5V120.5C93.1371 120.5 120 93.6371 120 60.5H118ZM60 2.5C92.0325 2.5 118 28.4675 118 60.5H120C120 27.3629 93.1371 0.5 60 0.5V2.5ZM60 0.5C26.8629 0.5 0 27.3629 0 60.5H2C2 28.4675 27.9675 2.5 60 2.5V0.5Z",
    fill: "#E6F2FA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_82"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 60.5C1 27.9152 27.4152 1.5 60 1.5V1.5C92.5848 1.5 119 27.9152 119 60.5V60.5C119 93.0848 92.5848 119.5 60 119.5V119.5C27.4152 119.5 1 93.0848 1 60.5V60.5Z",
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayInvoices);
export default __webpack_public_path__ + "static/media/PayInvoices.1e913687.svg";
export { ForwardRef as ReactComponent };